export const evProject = 'ev-landing';

export const evTrack = 'ev-landing';

export const giveawayProject = 'giveaway';

export const giveawayTrack = 'giveaway';

export const homeProject = 'home';

export const homeTrack = 'home';

export const semProject = 'sem';

export const semTrack = 'sem';

export const vdpLitePage = 'vdp-lite';

export const vdpStandardPage = 'vdp';

export const vdpTrack = 'vdp';
